import { toInteger } from '@ng-bootstrap/ng-bootstrap/util/util';
import { ContadorComponent } from './../contador/contador.component';
import { Component, ElementRef, Input, OnInit, ViewChild, OnChanges, DoCheck, Output } from '@angular/core';
import {MatPaginatorModule, MatPaginator, MatSort, MatTableDataSource, MatDialog, MatSidenavModule, MatTooltipModule} from '@angular/material';

import { SelectionModel, DataSource } from '@angular/cdk/collections';
import { HttpClient } from "@angular/common/http";
import { FileUploader } from 'ng2-file-upload';
import * as moment from "moment";
import { environment } from "environments/environment";

import { NgForm, FormGroup, FormControl, Validators, FormsModule  } from '@angular/forms';
import { formatDate, DatePipe } from '@angular/common';
import * as XLSX from 'xlsx';
import { element } from 'protractor';
import { componentRefresh } from '@angular/core/src/render3/instructions';
import { stringify } from '@angular/compiler/src/util';
import { GLOBALService } from "../../servicios/functions/GLOBAL.service";
//snackbar 1
import {MatSnackBar} from '@angular/material';
import { duration } from 'moment';
import { EventEmitter } from 'events';
import { RouterLink } from '@angular/router';
import { Router } from '@angular/router';

export interface PeriodicElement {
  i;
  codgasto;
  cuenta: string;
  concepto: string;
  leyenda: string;
  debe: string;
  origa: string;
}

var ELEMENT_DATA: PeriodicElement[] = [];

export interface PeriodicElement2 {
  i:string;
  cod_gasto: string;
  // fecha_carga: string;
  fecha_ticket: string;
  detalle: string;
  importe: string;
  categoria: string;
  imagen: string;
  //autorizante: string;
}
var ELEMENT_DATA2: PeriodicElement2[] = [];

@Component({
  selector: 'app-nuevaop',
  templateUrl: './nuevaop.component.html',
  styleUrls: ['./nuevaop.component.css']
})
export class NuevaopComponent implements OnInit, DoCheck {
  //vars
  fecha_hoy;
  fecha_vencimiento;
  ultop;
  loading;
  opactual;
  año;
  mes;
  dia;
  hoy;
  seccional = "BAHIA";
  dsSec;
  filtroSec;
  formaPago;
  cuentaBanco;
  descCuentaBanco; //la descpricion de la cuenta que selecicono para origen de los fondos
  nroOpera;
  tipoOrden;
  detExterno;
  impExterno;
  catExterno;
  dataSourceSeccionales; // cuando selecciono SISTEMA y carga las secc disponibles
  dataSourceGastos; // caso SISTEMA -->llena combobox con los gastos de esa seccional
  dataSourceGastosTEMP;
  dataSourceCategorias;
  itemTEMPORAL; //Para guardar temporalmente el item borrado
  filtroGAS;
  i;
  detallito = [];
  displayedColumns: string[] = ['i','codgasto','cuenta', 'concepto', 'leyenda', 'debe', 'origa','x'];
  dataSource = new MatTableDataSource(ELEMENT_DATA);
  @ViewChild(MatSort) sort: MatSort;
  puedepaga=false;
  arrgastos;
  detAdicional;

  constructor(
    private datePipe: DatePipe,
    private http: HttpClient,
    public dialog: MatDialog,
    public snackBar: MatSnackBar,
    private global: GLOBALService
    ){
      this.loading=true;
      this.fecha_hoy = new Date;
      this.fecha_hoy =  this.datePipe.transform(this.fecha_hoy,"yyyy-MM-dd");
      this.hoy=this.fecha_hoy;
      this.fecha_vencimiento = new Date;
      this.fecha_vencimiento.setDate(this.fecha_vencimiento.getDate() + 10);
      this.fecha_vencimiento = this.datePipe.transform(this.fecha_vencimiento,"yyyy-MM-dd")
        this.i=0;
   }

   llenarCategorias(){
     this.loading=true;
    //http://localhost:1337/api/llenarcategorias/ver?rol=ADMIN
    this.http.get(`${environment.backendUrl}/api/llenarcategorias/ver?rol=ADMIN`)
    .subscribe((data: any[]) => {
      this.dataSourceCategorias=data;
      console.log(this.dataSourceCategorias);
      this.loading=false; 
    });

  }

   guardarDetallito(){
    var gas;
    var cue;
    var conc
    var ley;
    var deb;
    var orig;
    //recorrer datasource de gastos traidos del sistema y obtener datos para llenar en grilla - dataSourceGastos
    if (this.filtroGAS && this.filtroGAS != 'TODOS'){
      //esto si elije 1 gasto..
      for (var _i = 0; _i < this.dataSourceGastos.length; _i++) {
        if (this.dataSourceGastos[_i]["COD_GASTO"] == this.filtroGAS){
          gas = this.dataSourceGastos[_i]["COD_GASTO"];
          cue = "----"
          conc = this.dataSourceGastos[_i]["DETALLE"];
          console.log(this.dataSourceGastos[_i]["DETALLE"]);
          console.log(conc);
          ley = '----';
          deb = this.dataSourceGastos[_i]["IMPORTE"];
        }
      }
    }
    //llena el data con los datos obtenidos de la instancia del gasto seleccionado para cargar el grid
    this.i = this.i + 1;
    let data = { i: this.i, codgasto: gas, cuenta: cue, concepto: conc,  leyenda: ley, debe: deb, origa: deb};
    console.log(data);
    ELEMENT_DATA.push(data);
    this.dataSource = new MatTableDataSource(ELEMENT_DATA);
    //this.detallito  = [];
    this.quitarItemDelDataSourceGastos();
  }
// SOLO GASTOS POR SISTEMA
  guardarDetallitoTODOS(){
    let data;
    if (this.filtroGAS == 'TODOS'){
      // hacer for recorriendo datasourcegastos y preparar data dentro de cada indice de i, y pushearlo al datasource del grid.
      for (var _i = 0; _i < this.dataSourceGastos.length; _i++) {
        let data = { i: _i+1, codgasto:this.dataSourceGastos[_i]["COD_GASTO"], cuenta:"----", concepto: this.dataSourceGastos[_i]["DETALLE"],  leyenda: "----", 
          debe: this.dataSourceGastos[_i]["IMPORTE"], origa: this.dataSourceGastos[_i]["IMPORTE"]};
        console.log(data);
        ELEMENT_DATA.push(data);
        this.dataSource = new MatTableDataSource(ELEMENT_DATA);
      }
      console.warn("FOR FOR FOR");
      this.quitarItemDelDataSourceGastos();
    }
  }

  //SOLO GASTOS EXTERNO
  guardarDetallitoEXTERNO(){
    //llena el data con los datos obtenidos de la instancia del gasto seleccionado para cargar el grid
    this.i = this.i + 1;
    let data = { i: this.i, codgasto: "000", cuenta: this.catExterno, concepto: this.detExterno,  leyenda: ("PAGOS VARIOS A SEC: " + this.filtroSec), debe: this.impExterno, origa: this.impExterno};
    console.warn("ELEMENT_DATA NEW");
    console.log(data);
    ELEMENT_DATA.push(data);
    this.dataSource = new MatTableDataSource(ELEMENT_DATA);
    this.snackBar.open(`Gasto añadido ok!`, 'Cerrar', {duration: 2000});
  }

  limpiarDatosExternos(){
    this.impExterno = null;
    this.detExterno = null;
    this.catExterno = null;
  }

  //refrescar el datasourcegastos para que se vea reflejado en el select
  quitarItemDelDataSourceGastos(){
    if (this.filtroGAS != 'TODOS' && this.filtroGAS){
      //esto si elije 1 gasto..
      for (var _i = 0; _i < this.dataSourceGastos.length; _i++) {
        if (this.dataSourceGastos[_i]["COD_GASTO"] == this.filtroGAS){
          this.dataSourceGastos.splice(_i, 1);
        }
      }
      console.warn("eliminando gasto del check")
    }
    if (this.filtroGAS == 'TODOS'){
      this.dataSourceGastos = [];
    }
    
  }

    
  removeAt(x){
    var impbo = 0;
    console.log(`borrando fila nro: ${x}`);
    //recorre el array y obtiene la posicion donde encuentre el dato a buscar (x)
    var index:number = this.dataSource.data.indexOf(this.dataSource.data.find(h => h.i == x));
    console.log(`posicion del elemento: ${index}`);
    //SOLO PARA GASTO SISTEMA
    if (this.tipoOrden=="SISTEMA"){
      console.warn(this.dataSource.data[index]["codgasto"]);
      console.warn(this.dataSource.data[index]["concepto"]); 
      let data = { COD_GASTO: this.dataSource.data[index]["codgasto"], DETALLE: this.dataSource.data[index]["concepto"],  DNI: "000", ESTADO: "AUTORIZADO", FECHA_CARGA: "2019-01-01", IMPORTE: this.dataSource.data[index]["debe"], MOTIVO: "VIAJE", USER:"MORGADE"};
      console.warn(data);
      this.dataSourceGastos.push(data);  
    }
    //borra desde la posicion que le mandas, y la cantidad que desees borrar contando esa posicion
    this.dataSource.data.splice(index, 1);
    this.dataSource.data.push();
    ELEMENT_DATA.push();
    this.dataSource = new MatTableDataSource(ELEMENT_DATA);
    this.contarArray(); 
    //al eliminarlo del grid, significa que lo vuelvo a poner en el select de busqueda de pagos..
  
 }

 registros;
 contarArray(){
   //console.log(this.dataSource.data.length);
   this.registros=this.dataSource.data.length;
 }

 temporal;
 enviaItem(temp){
   localStorage.setItem('itemTempo',temp);
   this.temporal=localStorage.getItem("itemTempo");
   console.log(temp);
 }



   deshabilitaRetroceso(){
    window.location.hash="no-back-button";
    window.location.hash="Again-No-back-button" //chrome
    window.onhashchange=function(){window.location.hash="no-back-button";}
  }
  
  sumatoria = 0;
  PUEDEPAGAR = false;
  TIENEFONDO = false;
  ngDoCheck(){
    //PARA LEYENDA DEL BANCO SELECCIONADO
    switch(this.cuentaBanco) { 
      case '111400': { 
         this.descCuentaBanco = 'BANCO NACION TRANSFERENCIA';
         break; 
      } 
      case '111402': { 
        this.descCuentaBanco = 'BANCO ITAU TRANSFERENCIA';
         break; 
      } 
      case '111401': { 
        this.descCuentaBanco = 'BANCO NACION CTA.CTE.';
         break; 
      }
      case '111403': { 
        this.descCuentaBanco = 'BANCO ITAU CTA.CTE.';
         break; 
      }
      //console.log(this.descCuentaBanco)
    } 
    console.log("DCH= "+ this.hoy);
    console.log("DCHFormaPago:" + this.formaPago);
    console.log("DCHCuentabanco:" + this.cuentaBanco);
    console.log("tipoorden: " + this.tipoOrden);
    console.warn("gasto:" + this.filtroGAS);
    if (this.dataSourceGastos){
      if (this.dataSourceGastos.length <=0){
        console.warn("APAGAR BOTON NO HAY GASTOS");
        this.puedepaga=false;
      }else{
        console.warn("PUEDE PAGAR");
        this.puedepaga=true;
      }
    console.log(this.dsArr);
    }
    // control de suma parcial segun el datasource o el grid
    this.sumarGastos();
    
    //hasta que puedepagar =true no habilita boton de pago
    if (this.tipoOrden == 'SISTEMA'){
      if (this.opactual != null && this.fecha_hoy != null && this.filtroSec != null && this.dataSource.data.length >=1 && this.formaPago != null && 
            this.formaPago != 'TARJETA' && this.cuentaBanco != null && this.nroOpera != null && this.nroOpera != ""){
        this.PUEDEPAGAR = true;
      }else{
            this.PUEDEPAGAR = false;
      }
    }
    
    //docheck de pago para gastos externos
    if (this.tipoOrden == 'EXTERNO'){
      if (this.opactual != null && this.fecha_hoy != null && this.filtroSec != null && this.dataSource.data.length >=1 && this.formaPago != null &&
             this.cuentaBanco != null && this.nroOpera != null && this.nroOpera != "" && this.filtroSec != '' && this.detAdicional != null && this.detAdicional != ''){
        this.PUEDEPAGAR = true;
      }else{
        this.PUEDEPAGAR = false;
      }
    }      
    this.contarArray();
    console.warn("NROOP: " + this.opactual + ", FECHAOP: " + this.fecha_hoy  + ",TIPOPAGO: " + this.tipoOrden + ",FILTROSEC: " + this.filtroSec + ", MOTIVO: " + this.detExterno + ",TIPOPAGO: " + this.formaPago + ",BANCO: " + this.cuentaBanco + ",NROPERA: " + this.nroOpera);
    console.warn("PUEDE PAGAR? " + this.PUEDEPAGAR);
    //muestra al final si cargo elementdat2
    if (ELEMENT_DATA2 && ELEMENT_DATA2.length != 0){
      console.log("ELEMENT_DATA2 FINAL");
      console.log(ELEMENT_DATA2)  
    }

    //muestra array de gastos si es x sistema
    if (this.tipoOrden == 'SISTEMA' && this.dataSource && this.dataSource.data.length>=1){
      this.arrgastos = [];
      var objetoGastos = [];
      console.warn("JSON DE GASTOS A PAGAR.."); 
      //recorre el datasource y arma un array de ids de gastos
      for (var _i = 0; _i < this.dataSource.data.length; _i++) {
        var gas = this.dataSource.data[_i]["codgasto"];
        if (gas){
          this.arrgastos.splice(0, 0, gas);
        }      
      }
      objetoGastos = this.arrgastos;
      this.arrgastos = JSON.stringify(this.arrgastos);
      this.arrgastos = this.arrgastos.replace("[","");
      this.arrgastos=this.arrgastos.replace("]","");
      this.arrgastos=this.arrgastos.replace(/ /g, "");
      console.warn(this.arrgastos);    
    }
    this.TIENEFONDO = false;
    if (this.fondito && this.fondito >=1){
      console.log("FONDOFIJO= " + this.fondito);
      this.TIENEFONDO = true;
      console.log("tiene fondo!");
    }else{
      this.TIENEFONDO = false;
      console.log("no tiene fondo..");
    }
  

  }

  sumarGastos(){
    this.sumatoria = 0;
    if (this.dataSource && this.dataSource.data.length !=0){
      for (var _i = 0; _i < this.dataSource.data.length; _i++) {
        this.sumatoria = this.sumatoria + parseFloat(this.dataSource.data[_i]["debe"]);
      }
    }
    console.log("**SUMATORIA: " + this.sumatoria);
  }

  ngOnInit() {
    this.llenarNoti();
    this.getUltimaOp();
    this.llenarComboSec()
    this.deshabilitaRetroceso();
    this.llenarCategorias();
  } 

  calcularSec(){
    if (this.tipoOrden == 'SISTEMA'){
      console.log("oksec!");
      this.calculaSeccionales();
    }
    else
    console.log("calcular EXTERNO");
  }

  noti;  
  llenarNoti(){
    //CARGA EL BOTON DE CONSULTA DE LOS ULTIMOS GASTOS RECIBIDOS..
      //http://localhost:1337/api/jorgenotifi/noti?est=AUTORIZADO
      this.http.get(`${environment.backendUrl}/api/jorgenotifi/noti?est=AUTORIZADO`)
        .subscribe((data: any[]) => {
        this.noti = data[0]["TOT"]; 
        localStorage.setItem('notipend',this.noti);
        console.log(`noti= ${localStorage.getItem('notipend')}`);   
      });
    }

  calculaSeccionales(){
    console.log("calculando SECCIONALES");
    //http://localhost:1337/api/calculasec/se?est=AUTORIZADO
    this.http.get(`${environment.backendUrl}/api/calculasec/se?est=AUTORIZADO`)
    .subscribe((datos: any[]) => {
      this.dataSourceSeccionales = datos; 
      console.log(this.dataSourceSeccionales); 
      this.loading=false;
    });
  
  }
//cuando haga click en la seccional a buscar gastos (si eligio SISTEMA)
  calcularGastosSistema(){
    if (this.filtroSec){
      this.calculaGastos();
    }
    if (this.tipoOrden == 'SISTEMA'){
      if (this.filtroSec != null && this.filtroSec != ''){
        this.calculaFondo(this.filtroSec);
      }
    }
    
  }
  
  fondito;
  calculaFondo(fsec){
    //http://localhost:1337/api/getseccionales/getid?idsec=03
    this.loading=true;
    this.http.get(`${environment.backendUrl}/api/getseccionales/getid?idsec=${fsec}`)
    .subscribe((data: any[]) => {
      this.fondito = data[0]["fondo_fijo"];
      console.warn(this.fondito);
      this.loading=false;
    });
  }

  calculaGastos(){
    this.loading=true;
    //http://localhost:1337/api/jorgevergastos/ver?iduser=TODOS_LOS_USUARIOS&motivo=TODOS_LOS_MOTIVOS&idsec=02&est=AUTORIZADO
    this.http.get(`${environment.backendUrl}/api/jorgevergastos/ver?iduser=TODOS_LOS_USUARIOS&motivo=TODOS_LOS_MOTIVOS&idsec=${this.filtroSec}&est=AUTORIZADO`)
    .subscribe((data: any[]) => {
      this.dataSourceGastos = data; 
      console.log("gastos encontrados!");
      console.warn(this.dataSourceGastos); 
      this.loading=false;
    });
  }

  getUltimaOp(){
    //http://localhost:1337/api/getultimopago/ult2
    this.loading=true;
    this.http.get(`${environment.backendUrl}/api/getultimopago/ult2`)
    .subscribe((datos: any[]) => {
      if (datos){
        this.ultop = datos["ULTIMO"];
        this.opactual = this.ultop+1;
        console.log("anteriorOP= "+ this.ultop);
        this.loading=false;
      }else{
        console.log("no hay op.");
        this.ultop = "0";
        this.opactual = this.ultop + 1;
        this.loading=false;
      }
    });
  }

  llenarComboSec(){
    this.loading=true;
    //http://localhost:1337/api/getseccionales/get
    this.http.get(`${environment.backendUrl}/api/getseccionales/get`)
    .subscribe((datos: any[]) => {
      if (datos){
        console.log("*************se llena el combo de seccionales.************");
        this.dsSec = datos[0];
        console.warn(this.dsSec[0]);
        this.loading=false;
      }else{
        console.log("no hay datos de sec..");
        this.loading=false;
      }
    });
  }

  dsArr;
  simulaEnviarFormulario(){//este es el que utiliza gasto ext
   this.loading=true;
   this.http.get(`${environment.backendUrl}/api/getultimopago/ult2`)
   .subscribe((datos: any[]) => {
     if (datos){
       this.ultop = datos["ULTIMO"];
       this.opactual = this.ultop+1;
       console.log("anteriorOP= "+ this.ultop);
       //PREPARO EL OBJETO PARA LOS DETALLES DEL NUEVO GASTO (NuevoDetalle)
       ELEMENT_DATA2 = [];
       for (var _i = 0; _i < this.dataSource.data.length; _i++) {
         let data = { i: this.i, cod_gasto: ELEMENT_DATA[_i]["codgasto"], fecha_ticket: this.fecha_hoy,  detalle: ELEMENT_DATA[_i]["concepto"], 
                 importe: ELEMENT_DATA[_i]["debe"], categoria: ELEMENT_DATA[_i]["cuenta"], imagen: 'lala.jpg' };
         ELEMENT_DATA2.push(data);
       }

       let bodyPago = {
         'detallePadre': this.detAdicional,//SE REEMPLAZA POR ELEMENT_DATA2
         'motivoPadre': 'GASTO-EXTERNO',
         'usuario': this.filtroSec,
         'fechaPadre': this.fecha_hoy,
         'obsPadre': 'GASTOEXTERNO',
         'estPadre': 'AUTORIZADO',
         'gastoDePadre': 'EXTERNO',
         'tipo_gasto': 'EXTERNO',
         'detalles': ELEMENT_DATA2,
           "arrgastos": "208,209,210,211", //SE hardcodea en backend (crea autoincrement y lo toma para el pago luego)
           "est": "PAGADO", // se hardcodea en backend
           "nropago": this.opactual, //autoincrementa frontend
           "fechapago": this.fecha_hoy,
           "importe": 200.23, // LO SACA DIRECTAMENTE DE LA TABLA GASTOS_DETALLE
           "tipo": "EXTERNO",
           "formapago": this.formaPago,
           "codcuen": this.cuentaBanco,
           "nroopera": this.nroOpera
         };       

       this.http.post(`${environment.backendUrl}/api/nuevaop/enviarformexternotest2`, bodyPago
       ).subscribe(
       res => {
         //NUNCA ENTRA POR ACA
         console.log("NUEVO GASTO GENERADO!",res);     
         this.loading=false;
         this.snackBar.open('GASTO EXTERNO GENERADO OK..', 'Cerrar', {duration: 2000});
       },
       error => {
         if (error.status == 200){ // aca entra si salio bien la insertada de gastos para pagar externos
          console.log("NUEVO GASTO GENERADO!");     
          this.loading=false;
          this.snackBar.open('GASTO EXTERNO GENERADO OK..', 'Cerrar', {duration: 2000});
      
          //LLAMO A ULTIMOS GASTOS INSERTADOS*********************************
          this.loading=true;
          //http://localhost:1337/api/getpago/getarr?can=03
          this.http.get(`${environment.backendUrl}/api/getpago/getarr?can=${ELEMENT_DATA2.length}`)
           .subscribe((datos: any[]) => {
            if (datos){
              console.log("::::datos de ultimos pagados:::::");
              this.dsArr = datos;
              console.warn(this.dsArr);
              this.loading=false;
              var arrayapagar='';
              for (var _i = 0; _i < this.dsArr.length; _i++) {
                if (arrayapagar==''){
                  arrayapagar = this.dsArr[_i]["ARR"];
                }else{
                  arrayapagar = arrayapagar + "," + this.dsArr[_i]["ARR"];
                }
              }
              console.log("ARRRRAAY A PAGAR: " + arrayapagar);
              //!!!PREPARAR EL ARRAY DE LOS GASTOS ACA! Y LUEGO EL PAGO!!!
              //http://localhost:1337/api/nuevaop/pagartransaction
              this.loading=true;
              var bod = {
                "arrgastos": arrayapagar,
                "est": "PAGADO",
                "nropago": this.opactual,
                "fechapago": this.fecha_hoy,
                "importe": 200.23,
                "tipo": "EXTERNO",
                "formapago": this.formaPago,
                "codcuen": this.cuentaBanco,
                "nroopera": this.nroOpera
              }
              this.http.post(`${environment.backendUrl}/api/nuevaop/pagartransaction`, bod).subscribe(
                res => console.log('---success pago', res),
                error => {
                if (error.status == 200){//++++++++++++++++++++todo ok!+++++++++++++++++++++++++
                  console.warn("INSERTADO EN BD PAGOS2!");   
                  this.snackBar.open(`PAGADO DB!`, 'Cerrar', {duration: 4000});
                  this.loading=false;
                  localStorage.setItem('codpag_edit', this.opactual);
                  //asigno esta op al localstorage para que me redirija al componente de impresion de orden de pago.
                  //refrescar numero de orden de pago proxima y blanquear datos..
                  this.getUltimaOp();
                  this.limpiar();
                  document.getElementById("botonImprime").click();
                }
                if (error.status == 500){
                  console.warn("ERROR DUPLICADO!");
                  console.log(JSON.stringify(error["error"]["code"]));
                  this.snackBar.open(`FALLO! ${JSON.stringify(error["error"]["code"])}`, 'Cerrar', {duration: 5000});
                  this.loading=false;
                }
              });
            }else{//si falla el obtener gastos
               console.log("fallo al obtener los ultimos gastos creados..");
               this.loading=false;
             }
           });  
        }
         if (error.status == 500){
           console.warn("ERROR AL CREAR NUEVOS GASTOS!");
           console.log(JSON.stringify(error["error"]["code"]));
           this.snackBar.open(`FALLO! ${JSON.stringify(error["error"]["code"])}`, 'Cerrar', {duration: 5000});
           this.loading=false;
         }
       });
     }

    });
  }
//JSON PARA GASTO EXTERNO NUEVO

  enviarFormulario(){
    //antes de pegarle al pago, consulto si realmente es la ultima ordenDePago para evitar conflictor de redundancia de OP
    //http://localhost:1337/api/getultimopago/ult2
    this.loading=true;
    this.http.get(`${environment.backendUrl}/api/getultimopago/ult2`)
    .subscribe((datos: any[]) => {
      if (datos){
        this.ultop = datos["ULTIMO"];
        this.opactual = this.ultop+1;
        console.log("anteriorOP= "+ this.ultop);

        //PREPARO EL OBJETO PARA LOS DETALLES DEL NUEVO GASTO (NuevoDetalle)
        ELEMENT_DATA2 = [];
        for (var _i = 0; _i < this.dataSource.data.length; _i++) {
          let data = { i: this.i, cod_gasto: ELEMENT_DATA[_i]["codgasto"], fecha_ticket: this.fecha_hoy,  detalle: ELEMENT_DATA[_i]["concepto"], 
                  importe: ELEMENT_DATA[_i]["debe"], categoria: ELEMENT_DATA[_i]["cuenta"], imagen: 'lala.jpg' };
          ELEMENT_DATA2.push(data);
        }
        
        let bodyPago = {
          'detallePadre': this.detAdicional,
          'motivoPadre': 'GASTO-EXTERNO',
          'usuario': this.filtroSec,
          'fechaPadre': this.fecha_hoy,
          'obsPadre': 'GASTOEXTERNO',
          'estPadre': 'AUTORIZADO',
          'gastoDePadre': 'EXTERNO',
          'tipo_gasto': 'EXTERNO',
          'detalles': ELEMENT_DATA2,
            "arrgastos": "208,209,210,211", //SE hardcodea en backend (crea autoincrement y lo toma para el pago luego)
            "est": "PAGADO", // se hardcodea en backend
            "nropago": this.opactual, //autoincrementa frontend
            "fechapago": this.fecha_hoy,
            "importe": 200.23, // LO SACA DIRECTAMENTE DE LA TABLA GASTOS_DETALLE
            "tipo": "EXTERNO",
            "formapago": this.formaPago,
            "codcuen": this.cuentaBanco,
            "nroopera": this.nroOpera
          };
        this.loading=true;         
        this.http.post(`${environment.backendUrl}/api/nuevaop/enviarformexterno`, bodyPago
        ).subscribe(
        res => {
          console.log("NUEVO GASTO GENERADO!",res);     
          this.loading=false;
          this.snackBar.open('PAGO ENVIADO CORRECTAMENTE!', 'Cerrar', {duration: 5000});
          //asigno esta op al localstorage para que me redirija al componente de impresion de orden de pago.
          localStorage.setItem('codpag_edit', this.opactual);
          //refrescar numero de orden de pago proxima y blanquear datos..
          this.getUltimaOp();
          document.getElementById("botonImprime").click();
          
        },
        error => {
          if (error.status == 200){
            console.warn("PAGO OK!");   
            this.snackBar.open(`PAGO OK!`, 'Cerrar', {duration: 5000});
            this.loading=false;
            localStorage.setItem('codpag_edit', this.opactual);
            //asigno esta op al localstorage para que me redirija al componente de impresion de orden de pago.
            //refrescar numero de orden de pago proxima y blanquear datos..
            this.getUltimaOp();
            this.limpiar();
            document.getElementById("botonImprime").click();
          }
          if (error.status == 500){
            console.warn("ERROR DUPLICADO!");
            console.log(JSON.stringify(error["error"]["code"]));
            this.snackBar.open(`FALLO! ${JSON.stringify(error["error"]["code"])}`, 'Cerrar', {duration: 5000});
            this.loading=false;
          }
        });
      }else{ //si no habia op cargada, 
        console.log("no hay op.");
        this.ultop = "0";
        this.opactual = this.ultop + 1;
        //preparamos datos de gasto externo y pago
       /*
        let data = { i: this.i, cod_gasto: '000', fecha_ticket: this.fecha_hoy,  detalle: this.dataSource.data[0]["concepto"], 
                  importe: this.sumatoria.toString(), categoria: this.dataSource.data[0]["cuenta"], imagen: 'lala.jpg' };
        console.log(data);
        ELEMENT_DATA2.push(data);
        console.log(ELEMENT_DATA2);
  */      
        //PREPARO EL OBJETO PARA LOS DETALLES DEL NUEVO GASTO (NuevoDetalle)
        ELEMENT_DATA2 = [];
        for (var _i = 0; _i < this.dataSource.data.length; _i++) {
          let data = { i: this.i, cod_gasto: ELEMENT_DATA[_i]["codgasto"], fecha_ticket: this.fecha_hoy,  detalle: ELEMENT_DATA[_i]["concepto"], 
                  importe: ELEMENT_DATA[_i]["debe"], categoria: ELEMENT_DATA[_i]["cuenta"], imagen: 'lala.jpg' };
          ELEMENT_DATA2.push(data);
        }
        let bodyPago = {
          'detallePadre': this.detAdicional,
          'motivoPadre': 'GASTO-EXTERNO',
          'usuario': this.filtroSec, //leugo preparar que tocando seccional elija al 1er user que encuentre
          'fechaPadre': this.fecha_hoy,
          'obsPadre': 'GASTOEXTERNO',
          'estPadre': 'AUTORIZADO',
          'gastoDePadre': 'EXTERNO',
          'tipo_gasto': 'EXTERNO',
          'detalles': ELEMENT_DATA2,
            "arrgastos": "208,209,210,211", //SE hardcodea en backend
            "est": "PAGADO", // se hardcodea en backend
            "nropago": this.opactual, //autoincrementa frontend
            "fechapago": this.fecha_hoy,
            "importe": 200.23, // LO SACA DIRECTAMENTE DE LA TABLA GASTOS_DETALLE
            "tipo": "EXTERNO",
            "formapago": this.formaPago,
            "codcuen": this.cuentaBanco,
            "nroopera": this.nroOpera
          };
        this.loading=true;         
        this.http.post(`${environment.backendUrl}/api/nuevaop/enviarformexterno`, bodyPago
        ).subscribe(
        res => {
          console.log("NUEVO GASTO GENERADO!",res);     
          this.loading=false;
          this.snackBar.open('PAGO ENVIADO CORRECTAMENTE!', 'Cerrar', {duration: 5000});
          //asigno esta op al localstorage para que me redirija al componente de impresion de orden de pago.
          localStorage.setItem('codpag_edit', this.opactual);
          //refrescar numero de orden de pago proxima y blanquear datos..
          this.getUltimaOp();
          this.limpiar();
          document.getElementById("botonImprime").click();
        },
        error => {
          if (error.status == 200){
            console.warn("PAGO OK!");   
            this.snackBar.open(`PAGO OK!`, 'Cerrar', {duration: 5000});
            this.loading=false;
            //asigno esta op al localstorage para que me redirija al componente de impresion de orden de pago.
            //refrescar numero de orden de pago proxima y blanquear datos..
            localStorage.setItem('codpag_edit', this.opactual);
            this.getUltimaOp();
            document.getElementById("botonImprime").click();
          }
          if (error.status == 500){
            console.warn("ERROR DUPLICADO!");
            console.log(JSON.stringify(error["error"]["code"]));
            this.snackBar.open(`FALLO! ${JSON.stringify(error["error"]["code"])}`, 'Cerrar', {duration: 5000});
            this.loading=false;
          }
        });
        
      }
    });

  }
  //PAGO POR SISTEMA
  pagar(){
   //http://localhost:1337/api/getultimopago/ult2
   this.loading=true;
   this.http.get(`${environment.backendUrl}/api/getultimopago/ult2`)
   .subscribe((datos: any[]) => {
     if (datos){
       this.ultop = datos["ULTIMO"];
       this.opactual = this.ultop+1;
       console.log("anteriorOP= "+ this.ultop);
       this.arrgastos = [];
       var objetoGastos = [];
       console.warn("JSON DE GASTOS A PAGAR.."); 
       //recorre el datasource y arma un array de ids de gastos
       for (var _i = 0; _i < this.dataSource.data.length; _i++) {
         var gas = this.dataSource.data[_i]["codgasto"];
         if (gas){
           this.arrgastos.splice(0, 0, gas);
         }      
       }
       objetoGastos = this.arrgastos;
       this.arrgastos = JSON.stringify(this.arrgastos);
       this.arrgastos = this.arrgastos.replace("[","");
       this.arrgastos=this.arrgastos.replace("]","");
       this.arrgastos=this.arrgastos.replace(/ /g, "");
       console.warn(this.arrgastos);
       console.warn(`${environment.backendUrl}/api/nuevaop/pagar?arrgastos=${this.arrgastos}&est=PAGADO&nropago=${this.opactual}&fechapago=${this.hoy}&importe=${this.sumatoria - this.fondito}&tipo=${this.tipoOrden}&formapago=${this.formaPago}&codcuen=${this.cuentaBanco}&nroopera=${this.nroOpera}`)
       //api para el pago
       //http://localhost:1337/api/nuevaop/pagar?arrgastos=208,209,210,211&est=PAGADO&nropago=01&fechapago=2019-10-15&importe=200.23&tipo=SISTEMA&formapago=CHEQUE&codcuen=111-300&nroopera=23233
       var result;
       this.loading=true;
       this.http.get(`${environment.backendUrl}/api/nuevaop/pagar?arrgastos=${this.arrgastos}&est=PAGADO&nropago=${this.opactual}&fechapago=${this.hoy}&importe=${this.sumatoria - this.fondito}&tipo=${this.tipoOrden}&formapago=${this.formaPago}&codcuen=${this.cuentaBanco}&nroopera=${this.nroOpera}`)
         .subscribe(
          res => {
            console.log(`PAGADO OK!!!!!!!!!!`);
            this.snackBar.open(`GASTOS PAGADOS OK!`, 'Cerrar', {duration: 4000});
            this.global.historicalTo("NUEVA OP / " + this.hoy,"PAGOS");      
            this.loading=false;
            //asigno esta op al localstorage para que me redirija al componente de impresion de orden de pago.
            localStorage.setItem('codpag_edit', this.opactual);
            this.limpiar();
            this.calcularSec();//refresco las seccionales para pagar
            document.getElementById("botonImprime").click();
          },
        error => {
          if (error.status == 200){
            console.log(`PAGADO OK!!!!!!!!!!`);
            this.snackBar.open(`GASTOS PAGADOS OK!`, 'Cerrar', {duration: 4000});
            this.global.historicalTo("NUEVA OP / " + this.hoy,"PAGOS");      
            this.loading=false;
            //asigno esta op al localstorage para que me redirija al componente de impresion de orden de pago.
            localStorage.setItem('codpag_edit', this.opactual);
            this.limpiar();
            this.calcularSec();//refresco las seccionales para pagar
            document.getElementById("botonImprime").click();
          }
          if (error.status == 500){
            this.loading=false;
            this.snackBar.open(`FALLO! intente nuevamente..`, 'Cerrar', {duration: 5000}); 
          }
        });
     }else{
       console.log("no hay op.");
       this.ultop = "0";
       this.opactual = this.ultop + 1;

       this.arrgastos = [];
       var objetoGastos = [];
       console.warn("JSON DE GASTOS A PAGAR.."); 
       //recorre el datasource y arma un array de ids de gastos
       for (var _i = 0; _i < this.dataSource.data.length; _i++) {
         var gas = this.dataSource.data[_i]["codgasto"];
         if (gas){
           this.arrgastos.splice(0, 0, gas);
         }      
       }
       objetoGastos = this.arrgastos;
       this.arrgastos = JSON.stringify(this.arrgastos);
       this.arrgastos = this.arrgastos.replace("[","");
       this.arrgastos=this.arrgastos.replace("]","");
       this.arrgastos=this.arrgastos.replace(/ /g, "");
       console.warn(this.arrgastos);
       console.warn(`${environment.backendUrl}/api/nuevaop/pagar?arrgastos=${this.arrgastos}&est=PAGADO&nropago=${this.opactual}&fechapago=${this.hoy}&importe=${this.sumatoria - this.fondito}&tipo=${this.tipoOrden}    &formapago=${this.formaPago}&codcuen=${this.cuentaBanco}&nroopera=${this.nroOpera}`)
       //api para el pago
       //http://localhost:1337/api/nuevaop/pagar?arrgastos=208,209,210,211&est=PAGADO&nropago=01&fechapago=2019-10-15&importe=200.23&tipo=SISTEMA&formapago=CHEQUE&codcuen=111-300&nroopera=23233
       var result;
       this.loading=true;
       this.http.get(`${environment.backendUrl}/api/nuevaop/pagar?arrgastos=${this.arrgastos}&est=PAGADO&nropago=${this.opactual}&fechapago=${this.hoy}&importe=${this.sumatoria - this.fondito}&tipo=${this.tipoOrden}    &formapago=${this.formaPago}&codcuen=${this.cuentaBanco}&nroopera=${this.nroOpera}`)
         .subscribe(
          res => {
            console.log(`PAGADO OK!!!!!!!!!!`);
            this.snackBar.open(`GASTOS PAGADOS OK!`, 'Cerrar', {duration: 4000});
            this.global.historicalTo("NUEVA OP / " + this.hoy,"PAGOS");      
            this.loading=false;
            //asigno esta op al localstorage para que me redirija al componente de impresion de orden de pago.
            localStorage.setItem('codpag_edit', this.opactual);
            this.limpiar();
            this.calcularSec();//refresco las seccionales para pagar
            document.getElementById("botonImprime").click();
          },
          error => {
          if (error.status == 200){
            console.log(`PAGADO OK!!!!!!!!!!`);
            this.snackBar.open(`GASTOS PAGADOS OK!`, 'Cerrar', {duration: 4000});
            this.global.historicalTo("NUEVA OP / " + this.hoy,"PAGOS");      
            this.loading=false;
            //asigno esta op al localstorage para que me redirija al componente de impresion de orden de pago.
            localStorage.setItem('codpag_edit', this.opactual);
            this.limpiar();
            this.calcularSec();//refresco las seccionales para pagar
            document.getElementById("botonImprime").click();
          }
          if (error.status == 500){
            this.loading=false;
            this.snackBar.open(`FALLO! intente nuevamente..`, 'Cerrar', {duration: 5000}); 
          }
        });
      }
    });
  }
  
  pagarPost(){
    var bod = {
      "arrgastos": "208,209,210,211",
      "est": "PAGADO",
      "nropago": "01",
      "fechapago": "2019-10-15",
      "importe": 200.23,
      "tipo": "SISTEMA",
      "formapago": "CHEQUE",
      "codcuen": "111-300",
      "nroopera": "23232"
    }
  
    this.http.post(`${environment.backendUrl}/api/nuevaop/pagartransaction`, bod)
    .subscribe(
      res => console.log('---success', res),
      error => {
        if (error.status == 200){
          console.warn("PAGO OK!");   
          this.snackBar.open(`PAGO OK!`, 'Cerrar', {duration: 5000});
        }
        if (error.status == 500){
          console.warn("ERROR DUPLICADO!");
          console.log(JSON.stringify(error["error"]["code"]));
          this.snackBar.open(`FALLO! ${JSON.stringify(error["error"]["code"])}`, 'Cerrar', {duration: 5000});
        }
      }
    );
    /*
  FUNCIONA PERO SIEMPRE SALE POR ERROR POR MAS QUE VENGA EN CODIGO 200
    this.http.post(`${environment.backendUrl}/api/nuevaop/pagartransaction`, bod)
        .subscribe((response: any) => {
          console.warn("RESPONSE= "+response);
          this.snackBar.open(`PAGO OK!`, 'Cerrar', {duration: 5000});
      }, (err: any) => {
        console.warn("RESPONSE" + err);
        this.snackBar.open(`FALLO! -${err}-, intente nuevamente..`, 'Cerrar', {duration: 5000});
      });
    }
  */
  }

  limpiar(){
    this.filtroGAS = '';
    this.filtroGAS = null;
    this.detAdicional = '';
    this.detExterno = '';
    this.impExterno = '';
    this.catExterno = '';
    this.formaPago = '';
    this.cuentaBanco = '';
    this.descCuentaBanco = '';
    this.sumatoria = 0;
    this.nroOpera = '';
    this.filtroSec = '';
    this.filtroSec = null;
    this.dataSource.data = [];
    ELEMENT_DATA = [];
    ELEMENT_DATA2 = [];
    this.fondito = 0;
    this.fondito = null;
  }
}
